module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-maedori4-bdeffa1cfec83c395b05859e0b4c1d5d.jpg";